import * as Marionette from "backbone.marionette";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {transient} from "aurelia-dependency-injection";

const template = require<string>("./no-results.html");

@backboneViewProperties({
    template
})

export class NoResultsView extends Marionette.ItemView<any> {

    constructor(options?) {
        super(options);
    }

    public render() {
        Marionette.ItemView.prototype.render.call(this);
        return this;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/no-results.ts